import { ConfigurationService } from '../services/configuration.service';
import { HtmlTextParser } from './html-text-parser.helper';

export default class DepartureBoardLinkHelper {
  private static getBaseUrl(): string {
    const baseUrl = ConfigurationService.get('departureBoardLinkGeneratorBaseUrl');
    if (!baseUrl) {
      throw new Error('Missing configuration for departureBoardLinkGeneratorBaseUrl');
    }
    return HtmlTextParser.decodeHtmlEntity(baseUrl);
  }

  public static generateLink(board1Gids: string[] | undefined, board2Gids: string[] | undefined, source: string): string {
    const params = new URLSearchParams();
    params.append('source', source);

    if (board1Gids) {
      board1Gids.forEach((gid) => params.append('board1Gids', gid));
      params.append('board1Modules', 'departures');
      params.append('board1Modules', 'trafficSituations');
      if (board1Gids.length > 1) {
        params.append('board1ShowPlatformsInHeader', 'false');
      }
    }
    if (board2Gids) {
      board2Gids.forEach((gid) => params.append('board2Gids', gid));
      params.append('board2Modules', 'departures');
      params.append('board2Modules', 'trafficSituations');
      if (board2Gids.length > 1) {
        params.append('board2ShowPlatformsInHeader', 'false');
      }
    }
    return `${this.getBaseUrl()}?${params.toString()}`;
  }
}
